import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Column, Button, TextInput } from '@pella/sash-framework';
import { savePostalCode, getLocalStorage } from '../../../utilities/functions';
import { getMarket, getBranch, getShowroom, getServiceInfo } from '../../../../actions/location-actions';
import styles from './index.module.scss';
import { navigate } from 'gatsby';
import { isValidPostal } from '../../../utilities/validations';

const RTAFreeConsultation = (props) => {
	// eslint-disable-next-line react/prop-types -- fix this
	const { title, content, buttonText, buttonColor, className, theme, virtual } = props;
	const [zip, setZip] = useState('50219');
	const [error, setError] = useState(false);
	const dispatch = useDispatch();

	// Grab zip code
	useEffect(() => {
		// Use localstorage version of postal code.
		if (getLocalStorage('UserPostalCode') != null) {
			setZip(getLocalStorage('UserPostalCode'));
		}
	}, []);

	// On Form Submit
	const onFormSubmit = (e) => {
		e.preventDefault();

		if (isValidPostal(zip)) {
			setError(false);
			savePostalCode(zip);
			dispatch(getMarket(zip));
			dispatch(getBranch(zip));
			dispatch(getShowroom(zip));
			dispatch(getServiceInfo(zip));
			navigate(`/where-to-buy/schedule-consultation/?postalCode=${zip}${virtual ? '&appointmentType=virtual' : ''}`);
		} else {
			setError(true);
		}
	};

	return (
		<div className={`${styles.rtaFreeConsultation} ${className || ''} ${theme === 'yellow' ? styles.rtaFreeConsultation_yellow : ''}`}>
			<h2 className={`s2-h2__alt`}>{title ? title : `Free In-Home Consultation`}</h2>
			{content ? <div dangerouslySetInnerHTML={{ __html: content }} /> : <p>FREE in-home consultation and measurement service. Enter your ZIP code to check availability in your area.</p>}

			<form
				className={styles.rtaFreeConsultation_Form}
				autoComplete='off'
				onSubmit={(el) => onFormSubmit(el)}
			>
				<Row noGutters={true}>
					<Column
						xs={12}
						md='fluid'
						lg={12}
						xxl='fluid'
					>
						<TextInput
							id='rtaPostalCode'
							placeholder='Enter Postal Code'
							labelText='Postal Code'
							hideLabel
							onChange={(e) => setZip(e.target.value)}
							value={zip}
							autoComplete='postal-code'
						/>
					</Column>

					<Column
						xs={12}
						md='auto'
						lg={12}
						xxl='auto'
					>
						<Button
							type='submit'
							color={buttonColor ? buttonColor : theme === 'yellow' ? 'primary-alt' : 'primary'}
							className={styles.rtaFreeConsultation_Button}
						>
							{buttonText ? buttonText : 'Schedule an In-Home Appointment'}
						</Button>
					</Column>

					{error && (
						<Column xs={12}>
							<p className={styles.rtaFreeConsultation_Error}>Please enter a valid postal code.</p>
						</Column>
					)}
				</Row>
			</form>
		</div>
	);
};

RTAFreeConsultation.propTypes = {
	title: PropTypes.string,
	content: PropTypes.string,
	buttonText: PropTypes.string,
	buttonColor: PropTypes.string,
	className: PropTypes.string,
	theme: PropTypes.string,
};

export default RTAFreeConsultation;
